<script lang="ts">
  import Popover from "@shared/svelte/Components/Popover/Popover.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  let showSource: boolean = false;

</script>

<span class="padding-top--smallest">
  <Popover arrow={false} bind:open={showSource} overlayColor="rgba(0,0,0,0)" widthStyle={"280px"}>
    <button slot="target" class="button button--link-flat margin-bottom--smallest">
      <Icon className="popover-icon" type="Info" height="15" width="15" />
    </button>
    <div slot="content" class="popover--inverted" style="padding: 16px">
      <div id="source-description" class="fizz-flow-16 fizz-text-left">
        <li>
          <strong>ProviPay</strong>: Paid on Provi via ProviPay
        </li>
        <li>
          <strong>Distributor</strong>: Distributor partners report payments made outside Provi,
          where available
        </li>
        <li>
          <strong>Self Reported</strong>: Manually reported by users in Provi
        </li>
      </div>
    </div>
  </Popover>
</span>
